/**
 * product.js — نغمة ستور
 * ------------------------------------------------------------
 * منطق صفحة المنتج الكامل: معرض الوسائط (تنقل/تكبير/مزامنة)، منتقي
 * الـVariant (تحديث حقيقي عبر Section Rendering API)، حقل الكمية، نموذج
 * الشراء (Ajax عبر cart/add.js وdrawer السلة المشترك)، وشريط الإضافة
 * السريعة الثابت الاختياري.
 *
 * تصحيح معماري جوهري (Product V5): سابقًا كانت هوية "التركيبة المختارة"
 * تُشتَق من data-variant-id (الـVariant الذي "سيتحقق" لو اختير هذا الخيار)،
 * ويُبنى الطلب كـ?variant=<id>. هذا يفشل بنيويًا في حالتين: (1) لا يمكن
 * تمييز "لم يتم اختيار شيء بعد" عن "تركيبة غير موجودة" محليًا بثقة كافية
 * دون معرفة الخادم؛ (2) Combined Listings (منتجات متعددة تُعرَض كمنتج واحد
 * بخيارات مشتركة) — التركيبة المختارة قد "تنتمي" لمنتج شقيق مختلف تمامًا
 * له product_url مختلف، لا يمكن معرفته من data-variant-id إطلاقًا.
 *
 * الحل: كل قيمة خيار تحمل الآن data-option-value-id (معرّف product_option_
 * value.id الحقيقي، فريد عالميًا لكل قيمة) وdata-product-url (رابط المنتج
 * الفعلي الذي تنتمي إليه هذه القيمة عند Combined Listings). عند كل تغيير
 * نجمع معرّف واحد لكل خيار بترتيب position، ونطلب Section Rendering API
 * دومًا عبر ?option_values=id1,id2,...&section_id=<id> — بصرف النظر عمّا
 * إذا كانت التركيبة الناتجة تطابق Variant حقيقية أم لا. الخادم (Liquid في
 * sections/main-product.liquid) هو من يقرر current_variant: تصحيح Product
 * V6 أعاد استخدام product.selected_or_first_available_variant مباشرة (لا
 * حلقة يدوية على product.variants كما كانت V5 تفترض خطأً — انظر تعليق
 * main-product.liquid للتفصيل الكامل)؛ هذا الفلتر نفسه يُعيد Variant فارغة
 * حين لا توجد تركيبة مطابقة لمعاملات option_values المُرسَلة، بلا Fallback
 * صامت لأي Variant عشوائية في هذه الحالة تحديدًا. الرد الناجح (حتى لو
 * "تركيبة غير متاحة") يُطبَّق دومًا هنا في الواجهة؛ Rollback يُستخدَم حصرًا
 * عند فشل الطلب نفسه شبكيًا (لا عند نجاحه بمحتوى "غير متاحة" — هذا نجاح،
 * لا فشل).
 *
 * تصحيح Product V6 (بند 3): عند انتماء القيمة المختارة لمنتج شقيق مختلف
 * ضمن Combined Listing (productUrl مختلف عن data-product-url الحالي)، لا
 * يكفي استبدال #ProductInfo وحده — يُستبدَل [data-product-page] بالكامل
 * (معرض/Breadcrumb/شريط ثابت/نموذج شراء)، ويُبَث حدث "naghmah:product-
 * changed" ليعيد assets/product-recommendations.js تحميل توصيات المنتج
 * الجديد تحديدًا (انظر applyProductSwap أدناه).
 *
 * كل مستمعي الأحداث التفاعلية (تغيير الخيار، الكمية، إرسال النموذج) مفوَّضة
 * (delegated) على مستوى document مرة واحدة فقط — بنفس نمط باقي ملفات
 * الثيم (cart-drawer.js، product-card.js، collection.js). هذا يعني أن
 * استبدال محتوى #ProductInfo-<sectionId> بالكامل بعد كل تحديث Variant لا
 * يحتاج أي "إعادة ربط" يدوي؛ المستمعات تستمر بالعمل تلقائيًا على العناصر
 * الجديدة فور ظهورها في DOM.
 *
 * استبدال المحتوى نفسه هو استبدال innerHTML للغلاف الثابت
 * #ProductInfo-<sectionId> (وليس استبدال العقدة بالكامل) — هذا يُبقي مرجع
 * العنصر الأب حيًا عبر IntersectionObserver الخاص بشريط الإضافة السريعة،
 * فلا حاجة لإعادة إنشائه من الصفر بعد كل تحديث Variant (فقط يُعاد ربطه
 * بعنصر أزرار الشراء الجديد داخل نفس الغلاف الثابت).
 *
 * تصحيح Product V3 (جولة تصحيح نهائية ومتكاملة):
 * 1. حالة كل صفحة منتج (WeakMap مفتاحها [data-product-page]) بدل متغيرات
 *    عامة مشتركة — يمنع إلغاء قسم منتج لطلب قسم آخر داخل محرر الثيم (عندما
 *    يتعايش أكثر من main-product واحد أثناء المعاينة/التكرار).
 * 2. حقل الكمية يُقرأ عبر form.elements.namedItem("quantity") (يجد العناصر
 *    المرتبطة بالنموذج عبر form="..." حتى لو كانت خارج <form> فعليًا في
 *    DOM)، لا form.querySelector(...) (يقتصر على الأحفاد المباشرين فقط).
 * 3. دورة حياة كاملة لتبديل Variant: حفظ آخر حالة ناجحة (HTML كامل
 *    لـ#ProductInfo)، تعطيل الشراء/الشراء السريع أثناء الجلب، استعادة آخر
 *    حالة ناجحة عند الفشل (لا الإبقاء على Variant قديمة مع منتقي جديد).
 * 4. فصل حالة "busy" المؤقتة عن حالة "متاح/غير متاح" الفعلية — بعد انتهاء
 *    busy تُقرأ حالة زر الإضافة الرئيسي من DOM الحالي مباشرة (لا من علم
 *    data-was-enabled قديم) وتُطبَّق على زر الشريط الثابت وزر الدفع السريع.
 */
(function () {
  "use strict";

  window.Naghmah = window.Naghmah || {};
  var Naghmah = window.Naghmah;

  var delegatedBound = false;
  var initializedGalleries = typeof WeakSet === "function" ? new WeakSet() : null;

  /* ================= حالة مستقلة لكل صفحة منتج ================= */
  /* تصحيح Product V3: كانت variantRequestSeq/variantRequestController/
     variantFetchBusy/stickyObserver متغيرات عامة واحدة يتشاركها كل قسم
     main-product على الصفحة — داخل محرر الثيم (حيث قد يتعايش أكثر من قسم
     منتج واحد أثناء المعاينة أو التكرار) كان تبديل Variant في قسم يُلغي
     طلب قسم آخر تمامًا (AbortController مشترك)، وكان IntersectionObserver
     الخاص بالشريط الثابت يُعاد ربطه بآخر قسم فقط (observer مشترك، آخر
     .observe() يفوز). الحل: WeakMap مفتاحها عنصر [data-product-page]
     نفسه — كل صفحة منتج تحصل على كائن حالة مستقل تمامًا، ويُحرَّر تلقائيًا
     من الذاكرة عند إزالة العنصر من DOM (WeakMap لا يمنع Garbage Collection). */
  var pageStates = typeof WeakMap === "function" ? new WeakMap() : null;
  var fallbackState = null; // احتياط نادر لبيئات بلا WeakMap (لن يحدث عمليًا في متصفحات Shopify المدعومة)

  function getPageState(pageRoot) {
    if (!pageStates) {
      if (!fallbackState) fallbackState = createPageState();
      return fallbackState;
    }
    var state = pageStates.get(pageRoot);
    if (!state) {
      state = createPageState();
      pageStates.set(pageRoot, state);
    }
    return state;
  }

  function createPageState() {
    return {
      variantSeq: 0,
      variantController: null,
      variantBusy: false,
      stickyObserver: null,
      lastGoodInfoHTML: null,
      addSeq: 0,
      /* تصحيح Product V5 (بند 6/7): addInFlight يمنع بدء طلب Add ثانٍ أو
         طلب تبديل Variant جديد أثناء طلب Add جارٍ فعليًا لنفس الصفحة؛
         addController يتيح إلغاء الاستماع لرد طلب Add عند إزالة القسم؛
         addMessageTimeout يحمل معرّف المؤقت الحالي لإعادة تعيين رسالة
         النجاح، حتى يمكن إلغاؤه عند إزالة القسم أو بدء طلب جديد. */
      addInFlight: false,
      addController: null,
      addMessageTimeout: null
      /* تصحيح Product V6 (بند 3): أُزيل حقل currentProductUrl الذي كان يحفظ
         productUrl الفعّال في State — أصبح data-product-url على pageRoot
         نفسه هو مصدر الحقيقة الوحيد (يُقرأ ويُكتَب مباشرة)، لأن Combined
         Listing أصبحت تستبدل pageRoot بالكامل (عنصر DOM جديد كليًا) بدل
         تحديث جزئي لـ#ProductInfo وحده — فلا معنى لحفظ productUrl في حالة
         مرتبطة بجذر قد يُستبدَل هو نفسه. */
    };
  }

  /* ================= أدوات مساعدة عامة ================= */

  function escapeAttrValue(value) {
    return String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }

  function getPageRoot(scopeEl) {
    if (scopeEl && scopeEl.closest) {
      var found = scopeEl.closest("[data-product-page]");
      if (found) return found;
    }
    return document.querySelector("[data-product-page]");
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }
    // احتياط بسيط لبيئات نادرة بلا CSS.escape — يكفي لمعرّفات Shopify
    // (حروف/أرقام/شرطات) المستخدمة فعليًا كقيم form.id في هذا الثيم.
    return String(value).replace(/([^\w-])/g, "\\$1");
  }

  /* ================= معرض الوسائط ================= */

  var zoomOverlay = null;
  var zoomCloseLabel = "";
  var zoomDialogLabel = "";
  /* تصحيح Product V2 (استكمال وصول Zoom Dialog): كانت النافذة تُفتح بلا حصر
     تركيز (Naghmah.trapFocus، نفس الأداة المستخدمة أصلاً في مغلَّق الجوال/
     Mega Menu/درج السلة) وبلا إعادة تركيز إلى الزر الذي فتحها فعليًا عند
     الإغلاق — رغم role="dialog" aria-modal="true"، كان Tab يهرب من الحوار
     إلى بقية الصفحة خلفه، وكان إغلاقها (بالزر أو Escape) يترك التركيز في
     مكان غير متوقَّع (غالبًا body) بدل العودة لصورة المعرض التي فُتحت منها.
     تصحيح Product V3: أُضيف aria-label عربي واضح (كان الحوار بلا اسم يُعلَن
     لقارئ الشاشة سوى محتواه)، وتتبُّع العنصر (pageRoot) المالك للحوار حتى
     يُغلَق تلقائيًا ويُنظَّف (src فارغة) عند إزالة قسمه عبر
     shopify:section:unload في محرر الثيم — بدل بقاء حوار "يتيم" يشير لقسم
     لم يعد موجودًا. */
  var zoomTriggerEl = null;
  var removeZoomFocusTrap = null;
  var zoomOwnerPageRoot = null;

  function openZoom(src, alt, triggerEl, ownerPageRoot) {
    if (!zoomOverlay) {
      zoomOverlay = document.createElement("div");
      zoomOverlay.className = "product-gallery-zoom";
      zoomOverlay.setAttribute("role", "dialog");
      zoomOverlay.setAttribute("aria-modal", "true");
      zoomOverlay.setAttribute("aria-label", zoomDialogLabel || "تكبير صورة المنتج");

      var closeBtn = document.createElement("button");
      closeBtn.type = "button";
      closeBtn.className = "product-gallery-zoom__close";
      closeBtn.setAttribute("data-zoom-close", "");
      closeBtn.setAttribute("aria-label", zoomCloseLabel || "إغلاق");

      var img = document.createElement("img");
      img.className = "product-gallery-zoom__image";
      img.setAttribute("data-zoom-image", "");
      img.alt = "";

      zoomOverlay.appendChild(closeBtn);
      zoomOverlay.appendChild(img);
      document.body.appendChild(zoomOverlay);

      zoomOverlay.addEventListener("click", function (evt) {
        if (evt.target === zoomOverlay || evt.target.closest("[data-zoom-close]")) {
          closeZoom(false);
        }
      });

      document.addEventListener("keydown", function (evt) {
        if (evt.key === "Escape" && zoomOverlay.classList.contains("is-open")) {
          closeZoom(false);
        }
      });
    } else {
      zoomOverlay.setAttribute("aria-label", zoomDialogLabel || "تكبير صورة المنتج");
    }

    var imgEl = zoomOverlay.querySelector("[data-zoom-image]");
    imgEl.src = src;
    imgEl.alt = alt || "";
    zoomOverlay.classList.add("is-open");
    Naghmah.lockScroll();

    zoomTriggerEl = triggerEl || document.activeElement || null;
    zoomOwnerPageRoot = ownerPageRoot || null;
    var closeButton = zoomOverlay.querySelector("[data-zoom-close]");
    removeZoomFocusTrap = Naghmah.trapFocus(zoomOverlay, closeButton);
  }

  /**
   * @param {boolean} forced صحيح فقط عند إغلاق ناتج عن إزالة القسم المالك
   *   (shopify:section:unload) — عندها تُفرَّغ src الصورة أيضًا (لا حاجة
   *   للاحتفاظ بصورة منتج لم يعد قسمه موجودًا)، ولا تُستعاد بؤرة التركيز
   *   إلى زر رُبما أُزيل هو الآخر مع نفس القسم.
   */
  function closeZoom(forced) {
    if (!zoomOverlay) return;
    zoomOverlay.classList.remove("is-open");
    Naghmah.unlockScroll();

    if (removeZoomFocusTrap) {
      removeZoomFocusTrap();
      removeZoomFocusTrap = null;
    }
    if (!forced && zoomTriggerEl && document.body.contains(zoomTriggerEl)) {
      zoomTriggerEl.focus();
    }
    if (forced) {
      var imgEl = zoomOverlay.querySelector("[data-zoom-image]");
      if (imgEl) {
        imgEl.src = "";
        imgEl.alt = "";
      }
    }
    zoomTriggerEl = null;
    zoomOwnerPageRoot = null;
  }

  function initGallery(pageRoot) {
    var gallery = pageRoot.querySelector("[data-product-gallery]");
    if (!gallery) return;
    if (initializedGalleries) {
      if (initializedGalleries.has(gallery)) return;
      initializedGalleries.add(gallery);
    }

    zoomCloseLabel = gallery.getAttribute("data-close-label") || zoomCloseLabel;
    zoomDialogLabel = gallery.getAttribute("data-zoom-dialog-label") || zoomDialogLabel;

    var stage = gallery.querySelector("[data-gallery-stage]");
    if (!stage) return;

    var items = Array.prototype.slice.call(stage.querySelectorAll("[data-gallery-item]"));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-thumb]"));
    var prevBtn = gallery.querySelector("[data-gallery-prev]");
    var nextBtn = gallery.querySelector("[data-gallery-next]");
    var activeIndex = 0;

    /* تصحيح Product V3 (بند 9، الحل الأبسط): الصور المصغّرة روابط مرساة
       حقيقية (<a href="#...">) بلا دلالة Tabs جزئية (كانت تحمل
       role="tablist"/"tab"/aria-selected بلا تنفيذ كامل لسلوك ARIA Tabs —
       لا roving tabindex ولا ArrowLeft/Right/Home/End). أُزيلت هذه
       الأدوار كليًا من Liquid، وأصبح التمييز عبر aria-current="true" فقط
       (يطابق دلالة "هذا هو العنصر الحالي ضمن مجموعة روابط"، وهو الاستخدام
       الرسمي الصحيح لـaria-current هنا) — لا حاجة لأي منطق ARIA إضافي في
       JS بعد الآن. */
    function setActive(index) {
      if (index < 0 || index >= items.length) return;
      activeIndex = index;
      thumbs.forEach(function (thumb, i) {
        var isActive = i === index;
        thumb.classList.toggle("is-active", isActive);
        if (isActive) {
          thumb.setAttribute("aria-current", "true");
        } else {
          thumb.removeAttribute("aria-current");
        }
      });
    }

    function goToIndex(index, smooth) {
      if (index < 0 || index >= items.length) return;
      items[index].scrollIntoView({
        inline: "start",
        block: "nearest",
        behavior: smooth && !Naghmah.prefersReducedMotion ? "smooth" : "auto"
      });
      setActive(index);
    }

    if (typeof IntersectionObserver === "function") {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              var idx = items.indexOf(entry.target);
              if (idx !== -1) setActive(idx);
            }
          });
        },
        { root: stage, threshold: [0.6] }
      );
      items.forEach(function (item) {
        observer.observe(item);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        goToIndex(activeIndex - 1, true);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        goToIndex(activeIndex + 1, true);
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener("click", function (evt) {
        evt.preventDefault();
        goToIndex(i, true);
      });
    });

    stage.addEventListener("keydown", function (evt) {
      if (evt.key === "ArrowRight") {
        evt.preventDefault();
        goToIndex(activeIndex + 1, true);
      } else if (evt.key === "ArrowLeft") {
        evt.preventDefault();
        goToIndex(activeIndex - 1, true);
      }
    });

    gallery.addEventListener("click", function (evt) {
      /* تصحيح Product V4 (بند 5): حارس إضافي احتياطي — عندما do_zoom=false
         لا يُخرِج Liquid عنصر data-gallery-zoom-trigger إطلاقًا (انظر
         product-media-gallery.liquid)، لكن هذا الحارس الصريح على صنف
         product-gallery--zoomable يمنع فتح التكبير حتى في حالات نادرة قد
         يتبقى فيها زر قديم من محتوى مُستبدَل جزئيًا (Section Rendering). */
      if (!gallery.classList.contains("product-gallery--zoomable")) return;
      var trigger = evt.target.closest("[data-gallery-zoom-trigger]");
      if (!trigger) return;
      var img = trigger.querySelector("img");
      if (!img) return;
      openZoom(img.currentSrc || img.src, img.alt, trigger, pageRoot);
    });

    // دالة عامة يستدعيها منطق تبديل الـVariant لتحديث الوسيط النشط دون
    // إعادة بناء المعرض بالكامل — تحافظ على حالة التمرير/التكبير الحالية.
    gallery._naghmahGoToMedia = function (mediaId) {
      if (!mediaId) return;
      var index = items.findIndex(function (item) {
        return item.getAttribute("data-media-id") === String(mediaId);
      });
      if (index !== -1) goToIndex(index, false);
    };

    /* تصحيح Product V2 (featured_media حسب ?variant=): data-initial-media-id
       يحمل فعليًا معرّف الوسيط الصحيح (مأخوذ من selected_variant.featured_
       media عندما يطابق current_variant رابط ?variant= الحالي)، لكن لم يكن
       شيء يستخدمه فعليًا عند التحميل الأول للصفحة — فقط عند تبديل Variant
       لاحقًا عبر _naghmahGoToMedia أعلاه. فتح رابط منتج مباشر مثل
       /products/x?variant=123 كان يعرض دومًا أول وسيط في ترتيب المنتج
       الافتراضي (product.media)، لا وسيط الـVariant المطلوب فعليًا. الآن
       يُنفَّذ نفس الانتقال (بلا تمرير سلس، فوري) مرة واحدة عند بناء المعرض. */
    var initialMediaId = gallery.getAttribute("data-initial-media-id");
    if (initialMediaId) {
      var initialIndex = items.findIndex(function (item) {
        return item.getAttribute("data-media-id") === String(initialMediaId);
      });
      if (initialIndex > 0) goToIndex(initialIndex, false);
    }
  }

  /* ================= إغلاق/تنظيف عند إزالة القسم (محرر الثيم) ================= */
  /* تصحيح Product V3 (بند 10): Zoom Dialog عنصر مشترك واحد يُلحَق بـ
     document.body مباشرة (ليس ابنًا لأي قسم main-product تحديدًا)، فلا
     يُزال تلقائيًا عند حذف القسم الذي فتحه من محرر الثيم. بلا هذا المستمع،
     كان بإمكان حوار مفتوح البقاء "معلَّقًا" يشير لصورة منتج قسمه لم يعد
     موجودًا في DOM. كذلك IntersectionObserver الخاص بالشريط الثابت يُفصَل
     صراحة (رغم أن WeakMap سيُحرِّر حالة القسم تلقائيًا عند تحرره من الذاكرة،
     فصل الـObserver فورًا أنظف ولا ينتظر دورة Garbage Collection).
     تصحيح Product V5 (بند 7): أُضيف أيضًا إلغاء state.addController (طلب
     Add قيد الانتظار فعليًا لهذا القسم تحديدًا) وتصفير أي مؤقت رسالة نجاح
     معلَّق (state.addMessageTimeout) — القسم أُزيل، فلا داعٍ لأي محاولة
     لاحقة لتحديث عناصره بعد وصول رد Add أو انتهاء مهلة رسالته. */
  document.addEventListener("shopify:section:unload", function (event) {
    var wrapper = event.target;
    if (!wrapper) return;

    if (zoomOwnerPageRoot && wrapper.contains && wrapper.contains(zoomOwnerPageRoot)) {
      closeZoom(true);
    }

    var pageRoot = wrapper.querySelector ? wrapper.querySelector("[data-product-page]") : null;
    if (pageRoot && pageStates) {
      var state = pageStates.get(pageRoot);
      if (state) {
        if (state.variantController) {
          try {
            state.variantController.abort();
          } catch (err) {
            /* لا شيء يستحق المعالجة — القسم يُزال أصلاً. */
          }
        }
        if (state.addController) {
          try {
            state.addController.abort();
          } catch (err) {
            /* لا شيء يستحق المعالجة. */
          }
        }
        if (state.addMessageTimeout) {
          window.clearTimeout(state.addMessageTimeout);
          state.addMessageTimeout = null;
        }
        if (state.stickyObserver) {
          state.stickyObserver.disconnect();
        }
      }
    }
  });

  /* ================= شريط الإضافة السريعة الثابت ================= */

  /**
   * تصحيح Product V4 (بند 4): كانت الدالة تتوقف بصمت إن غاب
   * [data-buy-buttons] (مثلاً للحظة بين إفراغ #ProductInfo وإعادة ملئه)
   * دون فصل الـObserver القديم أولاً ودون إخفاء الشريط الثابت — قد يبقى
   * الـObserver يراقب عنصرًا أُزيل من DOM (لا يُشغِّل شيئًا بعد الآن)، ويبقى
   * الشريط ظاهرًا/مخفيًا بحالته الأخيرة رغم تغيّر #ProductInfo بالكامل.
   * الحل: تُفصَل أي Observer سابقة أولًا دومًا؛ إن لم يعد [data-buy-buttons]
   * موجودًا، يُخفى الشريط الثابت صراحة ويُتوقَّف؛ وإلا يُنشَأ Observer عند
   * الحاجة ويُراقَب عنصر أزرار الشراء **الجديد** (بعد استبدال innerHTML).
   * تُستدعى هذه الدالة الآن من finishVariantBusy بعد كل نجاح/فشل تحديث
   * Variant، فتبقى المراقبة متزامنة مع #ProductInfo الحالي دومًا.
   */
  function attachStickyObserver(pageRoot, sectionId) {
    var state = getPageState(pageRoot);
    var stickyBar = pageRoot.querySelector("[data-sticky-bar]");
    if (!stickyBar) return;

    if (state.stickyObserver) {
      state.stickyObserver.disconnect();
    }

    var infoWrap = document.getElementById("ProductInfo-" + sectionId);
    var buyButtons = infoWrap ? infoWrap.querySelector("[data-buy-buttons]") : null;

    if (!buyButtons) {
      stickyBar.hidden = true;
      stickyBar.classList.remove("is-visible");
      return;
    }

    if (!state.stickyObserver && typeof IntersectionObserver === "function") {
      state.stickyObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var bar = pageRoot.querySelector("[data-sticky-bar]");
          if (!bar) return;
          bar.hidden = entry.isIntersecting;
          bar.classList.toggle("is-visible", !entry.isIntersecting);
        });
      }, { threshold: 0 });
    }

    if (state.stickyObserver) {
      state.stickyObserver.observe(buyButtons);
    }
  }

  /**
   * تصحيح Product V3 (بند 5): تُقرأ حالة "متاح/غير متاح" من زر الإضافة
   * الرئيسي في #ProductInfo الحالي مباشرة (وهو دومًا الحقيقة الفعلية بعد
   * أي استبدال innerHTML ناجح أو استعادة لآخر حالة ناجحة) — لا من أي علم
   * محفوظ مسبقًا (data-was-enabled سابقًا). تُستدعى فقط بعد انتهاء busy
   * (نجاحًا أو فشلًا)، فتُطبَّق الحالة الحقيقية دومًا على زر الشريط الثابت
   * وزر الدفع السريع معًا.
   */
  function syncStickyBarFromInfo(pageRoot, sectionId) {
    var stickyBar = pageRoot.querySelector("[data-sticky-bar]");
    var infoWrap = document.getElementById("ProductInfo-" + sectionId);
    if (!infoWrap) return;

    var priceBlock = infoWrap.querySelector("[data-price-block]");
    if (stickyBar) {
      var priceEl = stickyBar.querySelector("[data-sticky-bar-price]");
      if (priceBlock && priceEl) {
        priceEl.textContent = priceBlock.textContent.trim();
      }
    }

    var addButton = infoWrap.querySelector("[data-add-to-cart-button]");
    var variantAvailable = addButton ? !addButton.disabled : false;

    if (stickyBar) {
      var stickyAddButton = stickyBar.querySelector("[data-sticky-bar-add]");
      if (stickyAddButton && addButton) {
        stickyAddButton.disabled = !variantAvailable;
        stickyAddButton.setAttribute("aria-disabled", variantAvailable ? "false" : "true");
        stickyAddButton.textContent = addButton.textContent.trim();
      }
    }

    setDynamicCheckoutDisabled(infoWrap, !variantAvailable);
  }

  /* ================= منتقي الـVariant (Section Rendering) ================= */

  /**
   * تصحيح Product V3 (بند 6): [data-dynamic-checkout] هو الغلاف حول
   * {{ form | payment_button }} — محتواه HTML/JS من Shopify نفسها (زر
   * Apple Pay/Shop Pay/إلخ)، لا نتحكم بعناصره الداخلية مباشرة. تعطيله
   * فعليًا (بلا كسر شكله) يحتاج ثلاث طبقات معًا: (1) aria-disabled للإعلان
   * الدلالي، (2) خاصية inert (مدعومة في كل المتصفحات الحديثة) تمنع أي
   * تفاعل فأرة/لوحة مفاتيح بالكامل وتُخفيه عن شجرة الوصول، (3) class
   * ليُطبَّق pointer-events:none/التعتيم بصريًا في CSS كطبقة احتياط لأي
   * متصفح لا يدعم inert بعد.
   */
  function setDynamicCheckoutDisabled(infoWrap, disabled) {
    var dynamicCheckout = infoWrap ? infoWrap.querySelector("[data-dynamic-checkout]") : null;
    if (!dynamicCheckout) return;
    if (disabled) {
      dynamicCheckout.setAttribute("aria-disabled", "true");
      dynamicCheckout.classList.add("is-disabled");
      try {
        dynamicCheckout.inert = true;
      } catch (err) {
        /* متصفح لا يدعم inert — الطبقتان الأخريان (aria-disabled + CSS) تبقيان فعّالتين. */
      }
    } else {
      dynamicCheckout.removeAttribute("aria-disabled");
      dynamicCheckout.classList.remove("is-disabled");
      try {
        dynamicCheckout.inert = false;
      } catch (err) {
        /* لا شيء مطلوب. */
      }
    }
  }

  function reinitShopifyPaymentButton() {
    if (
      window.Shopify &&
      window.Shopify.PaymentButton &&
      typeof window.Shopify.PaymentButton.init === "function"
    ) {
      window.Shopify.PaymentButton.init();
    }
  }

  /**
   * تصحيح Product V5 (بند 6): تنفيذ حقيقي يضمن دخول selling_plan
   * وproperties[...] ضمن FormData/الإرسال الأصلي/الدفع السريع معًا. أي حقل
   * بهذين الاسمين يعيش داخل pageRoot (مثلاً App Block يُعرض عبر {% render
   * block %} ضمن #ProductInfo) لكن بلا ارتباط بأي <form> — لا سلف <form>
   * ولا form="..." — يُربَط برمجيًا بنموذج المنتج الحقيقي عبر خاصية form
   * (تكافئ form="..." في HTML). حقل يعيش فعليًا داخل <form> أخرى مستقلة
   * (سلف حقيقي أو form="..." يشير لمعرّف آخر) لا يُمَس إطلاقًا — لا يُنتزَع
   * من سياقه. تُستدعى عند تهيئة كل صفحة منتج وبعد كل Section Rendering
   * ناجح (نجاحًا أو استعادة)، لتغطية حقول قد تظهر/تختفي مع تغيّر Variant.
   */
  function bindFormAssociatedFields(pageRoot) {
    var sectionId = pageRoot.getAttribute("data-section-id");
    var form = document.getElementById("ProductForm-" + sectionId);
    if (!form) return;

    var candidates = pageRoot.querySelectorAll('[name="selling_plan"], [name^="properties["]');
    candidates.forEach(function (field) {
      var ownForm = field.form; // خاصية HTMLFormElement.form الأصلية: تحترم form="..." الصريحة أو أقرب <form> سلف
      if (ownForm) return; // مرتبط فعلاً (بنموذجنا أو بنموذج مستقل آخر) — لا يُمَس إطلاقًا
      try {
        field.setAttribute("form", form.id);
      } catch (err) {
        /* لا شيء مطلوب — حقل نادر لا يقبل خاصية form (غير متوقَّع عمليًا). */
      }
    });
  }

  /**
   * تصحيح Product V5 (بند 1): تجمع معرّف Product Option Value المختار
   * حاليًا لكل خيار، بترتيب option.position تصاعديًا — معرّف واحد بالضبط
   * لكل خيار (لا للـVariant الكاملة). نمط buttons: input[data-option-value-
   * id]:checked ضمن fieldset الخيار. نمط dropdown: العنصر المحدَّد فعليًا
   * (selectedIndex) ضمن <select data-option-position>. الترتيب مضمون عبر
   * فرز عناصر <fieldset data-option-position> رقميًا قبل القراءة (لا يعتمد
   * على ترتيب ظهورها في DOM، الذي قد يختلف لو أعاد محرر الثيم ترتيب الكتل).
   */
  function collectSelectedOptionValueIds(picker) {
    var fieldsets = Array.prototype.slice.call(picker.querySelectorAll("fieldset[data-option-position]"));
    fieldsets.sort(function (a, b) {
      return parseInt(a.getAttribute("data-option-position"), 10) - parseInt(b.getAttribute("data-option-position"), 10);
    });

    var ids = [];
    fieldsets.forEach(function (fieldset) {
      var select = fieldset.querySelector("select[data-option-position]");
      if (select) {
        var selectedOption = select.options[select.selectedIndex];
        if (selectedOption) ids.push(selectedOption.getAttribute("data-option-value-id"));
        return;
      }
      var checkedRadio = fieldset.querySelector("input[data-option-value-id]:checked");
      if (checkedRadio) ids.push(checkedRadio.getAttribute("data-option-value-id"));
    });
    return ids;
  }

  /**
   * تصحيح Product V6 (بند 5): كانت fetchVariantUpdate تبني رابط طلب Section
   * Rendering بدمج نصي مباشر (`productUrl + "?option_values=..." + "&section_id=..."`)
   * — هذا يحذف أي معامل آخر موجود فعليًا في رابط الصفحة الحالي (أخطرها
   * `selling_plan`: لو كان الزائر قد اختار خطة اشتراك معيّنة، الرابط الحالي
   * يحملها، لكن طلب Section Rendering لتبديل الـVariant لم يكن يرسلها إطلاقًا،
   * فيرسم الخادم Product Form/Dynamic Checkout وفق الخطة الافتراضية لا
   * المختارة فعليًا). الحل: بناء رابط الطلب عبر واجهة URL القياسية، مع نسخ كل
   * معاملات الرابط الحالي (window.location) إلى رابط الطلب أولاً، فيما عدا
   * variant/option_values/section_id (تُضبَط لاحقًا صراحة) — فتبقى
   * selling_plan وأي معامل آخر (تتبّع/حملة) محفوظة في الطلب نفسه، لا فقط في
   * شريط العنوان لاحقًا.
   */
  function buildSectionRenderingUrl(productUrl, sectionId, optionValueIds) {
    var requestUrl;
    try {
      requestUrl = new URL(productUrl, window.location.origin);
    } catch (err) {
      requestUrl = new URL(window.location.href);
    }

    try {
      var currentUrl = new URL(window.location.href);
      currentUrl.searchParams.forEach(function (value, key) {
        if (key === "variant" || key === "option_values" || key === "section_id") return;
        requestUrl.searchParams.set(key, value);
      });
    } catch (err) {
      /* بيئة نادرة بلا URL API فعّالة — يبقى الطلب بلا معاملات إضافية منسوخة. */
    }

    requestUrl.searchParams.delete("variant");
    requestUrl.searchParams.set("option_values", optionValueIds.join(","));
    requestUrl.searchParams.set("section_id", sectionId);

    return requestUrl.toString();
  }

  /**
   * تصحيح Product V5 (بند 3): تحديث رابط العنوان دون حذف أي معامل آخر
   * موجود فعليًا (selling_plan، أو أي معامل تتبّع/حملة). نبني nextUrl من
   * window.location.href الحالي كاملاً (لا من productUrl فقط، الذي يحمل
   * المسار فقط بلا أي من هذه المعاملات) عبر واجهة URL القياسية، ثم نُبدِّل
   * المسار (pathname) فقط إن تغيّر productUrl فعليًا (Combined Listing)،
   * ثم نضبط variant/option_values حصرًا. hash الحالي (إن وُجد) يبقى كما هو
   * تلقائيًا لأننا لم نلمسه إطلاقًا.
   */
  function updateUrlForSelection(productUrl, matchedVariantId, optionValueIds) {
    try {
      var nextUrl = new URL(window.location.href);
      try {
        var targetPath = new URL(productUrl, window.location.origin).pathname;
        nextUrl.pathname = targetPath;
      } catch (pathErr) {
        /* productUrl غير صالح كرابط مطلق/نسبي — يبقى المسار الحالي كما هو. */
      }

      if (matchedVariantId) {
        nextUrl.searchParams.set("variant", matchedVariantId);
        nextUrl.searchParams.delete("option_values");
      } else {
        nextUrl.searchParams.delete("variant");
        nextUrl.searchParams.set("option_values", optionValueIds.join(","));
      }

      window.history.replaceState({}, "", nextUrl.pathname + nextUrl.search + nextUrl.hash);
    } catch (err) {
      /* بيئة نادرة بلا History/URL API فعّالة — لا يكسر التحديث المرئي للصفحة. */
    }
  }

  function applyVariantUpdate(pageRoot, sectionId, html, focusOptionPosition, focusOptionValueId, refocusSelect) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var infoId = "ProductInfo-" + sectionId;
    var newInfo = doc.getElementById(infoId);
    var currentInfo = document.getElementById(infoId);
    if (!newInfo || !currentInfo) return { applied: false, matchedVariantId: null };

    currentInfo.innerHTML = newInfo.innerHTML;

    /**
     * تصحيح Product V5 (بند 4): إعادة التركيز تعتمد الآن على data-option-
     * value-id (فريد عالميًا)، لا على تركيبة data-option-value (الاسم) —
     * تُزيل الحاجة لاكتشاف <option> وإعادة التوجيه إلى <select> يدويًا كما
     * في V4 (كان الاكتشاف ضروريًا لأن نفس المحدِّد كان يطابق <option> في
     * نمط القائمة)؛ هنا نطلب صراحةً select[data-option-position] لنمط
     * القائمة، أو input[data-option-value-id] لنمط الأزرار — كل منهما يُعيد
     * العنصر القابل للتركيز الصحيح مباشرة بلا أي التفاف إضافي. legend
     * القيمة المختارة (data-option-selected-value) لا تحتاج أي تحديث يدوي
     * هنا: محتواها جزء من newInfo.innerHTML نفسه المُطبَّق للتو، ويعكس
     * دومًا القيم المختارة فعليًا في هذا الطلب بالذات — بما فيها حالة
     * تركيبة غير موجودة (Liquid يضبط option.selected_value وفق الطلب دون
     * حاجة لوجود Variant مطابقة إجمالاً).
     */
    try {
      if (focusOptionPosition != null && focusOptionValueId) {
        var refocusTarget = refocusSelect
          ? currentInfo.querySelector('select[data-option-position="' + focusOptionPosition + '"]')
          : currentInfo.querySelector('input[data-option-value-id="' + escapeAttrValue(focusOptionValueId) + '"]');
        if (refocusTarget) refocusTarget.focus({ preventScroll: true });
      }
    } catch (err) {
      /* محدِّد غير صالح في حالة نادرة — لا يكسر التحديث، فقط لا تُعاد بؤرة التركيز تحديدًا. */
    }

    var newGallery = doc.querySelector('[data-product-gallery][data-section-id="' + sectionId + '"]');
    var currentGallery = pageRoot.querySelector('[data-product-gallery][data-section-id="' + sectionId + '"]');
    if (newGallery && currentGallery && currentGallery._naghmahGoToMedia) {
      var newMediaId = newGallery.getAttribute("data-initial-media-id");
      currentGallery._naghmahGoToMedia(newMediaId);
    }

    /**
     * تصحيح Product V4 (بند 7): صورة الشريط الثابت (Sticky Bar) تعيش خارج
     * #ProductInfo (في main-product.liquid مباشرة)، فلا تُستبدَل تلقائيًا
     * ضمن استبدال innerHTML أعلاه. تُقرأ [data-sticky-bar-image] من HTML
     * الكامل الذي أعادته Shopify لهذا القسم (وليس فقط من #ProductInfo)،
     * وتُحدَّث src/srcset/width/height للصورة الحية مباشرة. Liquid نفسه
     * (main-product.liquid) يحسب fallback الصحيح دومًا (صورة الـVariant
     * الجديدة، أو صورة المنتج الافتراضية) — فإن لم توجد صورة إطلاقًا في
     * الرد الجديد (نادر جدًا)، تُخفى الصورة الحية بدل إبقاء صورة Variant
     * السابقة ظاهرة خطأً.
     */
    var newStickyImage = doc.querySelector("[data-sticky-bar-image]");
    var currentStickyImage = pageRoot.querySelector("[data-sticky-bar-image]");
    if (currentStickyImage) {
      var newSrc = newStickyImage ? newStickyImage.getAttribute("src") : "";
      if (newSrc) {
        currentStickyImage.src = newSrc;
        if (newStickyImage.hasAttribute("srcset")) {
          currentStickyImage.setAttribute("srcset", newStickyImage.getAttribute("srcset"));
        } else {
          currentStickyImage.removeAttribute("srcset");
        }
        if (newStickyImage.hasAttribute("width")) currentStickyImage.setAttribute("width", newStickyImage.getAttribute("width"));
        if (newStickyImage.hasAttribute("height")) currentStickyImage.setAttribute("height", newStickyImage.getAttribute("height"));
        currentStickyImage.hidden = false;
      } else {
        currentStickyImage.removeAttribute("src");
        currentStickyImage.removeAttribute("srcset");
        currentStickyImage.hidden = true;
      }
    }

    /* تصحيح Product V5 (بند 2/3): معرّف Variant المطابقة فعليًا (إن وُجدت)
       يُقرأ من الحقل المخفي نفسه بعد التطبيق — قيمة فارغة تعني أن Shopify
       لم تجد Variant تطابق التركيبة المختارة (لا يعني هذا فشل الطلب، بل
       نجاحه بمحتوى "تركيبة غير متاحة" الذي طبّقناه للتو بنجاح أعلاه). هذا
       هو الأساس الذي يقرر عليه استدعاء fetchVariantUpdate ما إذا يُحدِّث
       الرابط بـ?variant= أو يُبقيه على ?option_values=. */
    var idField = currentInfo.querySelector("[data-buy-buttons-variant-id]");
    var matchedVariantId = idField && idField.value ? idField.value : null;

    return { applied: true, matchedVariantId: matchedVariantId };
  }

  /**
   * تصحيح Product V6 (بند 3): كانت V5 تستبدل #ProductInfo فقط حتى عند
   * الانتقال إلى منتج شقيق ضمن Combined Listing (productUrl مختلف تمامًا) —
   * فيبقى المعرض/الوسائط، Breadcrumb، عنوان/صورة الشريط الثابت، وdata-
   * product-id/data-product-url على pageRoot نفسه تخص المنتج **القديم**،
   * بينما السعر/الوصف فقط يتغيران داخل #ProductInfo. الحل: عند اكتشاف تغيّر
   * المنتج (productChanged)، تُستبدَل كامل [data-product-page] — لا
   * #ProductInfo وحده — بالعقدة الجديدة المُستخرَجة من رد Section Rendering
   * ذاته (القسم main-product بأكمله، بما فيه المعرض/Breadcrumb/الشريط
   * الثابت/نموذج الشراء، إذ Section Rendering API تُعيد فعليًا مخرجات
   * sections/main-product.liquid كاملة لهذا القسم، وجذرها هو
   * [data-product-page] نفسه).
   *
   * قبل الاستبدال: تُنظَّف حالة الجذر القديم بالكامل (إلغاء Variant/Add
   * Controllers، فصل Sticky Observer، إغلاق Zoom إن كانت مملوكة له، تصفير
   * مؤقتات الرسائل) — بنفس منطق مستمع shopify:section:unload تحديدًا، لأن
   * الجذر القديم يُزال فعليًا من DOM هنا بنفس الطريقة. بعد الاستبدال: يُبَث
   * حدث "naghmah:product-changed" (يحمل oldProductId/productId/
   * sourceSectionId/productUrl/pageRoot الجديد) ليستمع إليه أي كود آخر
   * يحتاج معرفة تغيّر المنتج (حاليًا: assets/product-recommendations.js)،
   * ثم تُشغَّل initSection على الجذر الجديد لتهيئته بالكامل من الصفر
   * (معرض، Sticky Observer، ربط الحقول، لقطة lastGoodInfoHTML جديدة تخص
   * المنتج الجديد).
   *
   * تصحيح Product V7 (بند 3): oldProductId يُقرأ من الجذر القديم قبل أي
   * تنظيف أو استبدال (data-product-id عليه في تلك اللحظة يخص المنتج
   * الحالي فعليًا قبل التغيير) ويُضاف لتفاصيل الحدث، ليتمكن
   * assets/product-recommendations.js من تحديد أي عنصر توصيات يخصّه هذا
   * التغيير تحديدًا (data-product-id == oldProductId) بدل تحديث كل عنصر
   * توصيات موجود في الصفحة دون شرط. sourceSectionId هو sectionId الممرَّر
   * لهذه الدالة (معرّف قسم main-product الذي بدأ الطلب).
   *
   * تصحيح Product V7 (بند 4): document.title ورابط <link rel="canonical">
   * يُحدَّثان هنا فقط — تحديدًا لأن applyProductSwap لا تُستدعى إطلاقًا إلا
   * حين productChanged=true (انظر fetchVariantUpdate)، فلا خطر تحديثهما
   * خطأً عند تبديل Variant عادي لنفس المنتج. القيم الجديدة تُقرأ من
   * data-document-title/data-canonical-url على الجذر الجديد المستورد
   * (sections/main-product.liquid تُخرجهما من product.title/shop.name
   * وcanonical_url الفعليين وقت التصيير من الخادم) — لا حساب محلي هنا قد
   * يخطئ (مثلاً تجاهل selling_plan أو معاملات أخرى في الرابط الحالي).
   */
  function applyProductSwap(oldPageRoot, sectionId, html, requestedProductUrl, focusOptionPosition, focusOptionValueId, refocusSelect) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var newPageRootTemplate = doc.querySelector("[data-product-page]");
    if (!newPageRootTemplate || !oldPageRoot.parentNode) {
      return { applied: false, matchedVariantId: null, newPageRoot: null };
    }

    var oldProductId = oldPageRoot.getAttribute("data-product-id") || "";

    var oldState = getPageState(oldPageRoot);
    if (oldState.variantController) {
      try {
        oldState.variantController.abort();
      } catch (err) {
        /* لا شيء يستحق المعالجة. */
      }
    }
    if (oldState.addController) {
      try {
        oldState.addController.abort();
      } catch (err) {
        /* لا شيء يستحق المعالجة. */
      }
    }
    if (oldState.addMessageTimeout) {
      window.clearTimeout(oldState.addMessageTimeout);
      oldState.addMessageTimeout = null;
    }
    if (oldState.stickyObserver) {
      oldState.stickyObserver.disconnect();
    }
    if (zoomOwnerPageRoot && (zoomOwnerPageRoot === oldPageRoot || oldPageRoot.contains(zoomOwnerPageRoot))) {
      closeZoom(true);
    }

    var importedNode = document.importNode(newPageRootTemplate, true);
    oldPageRoot.replaceWith(importedNode);

    var newProductId = importedNode.getAttribute("data-product-id") || "";
    var newProductUrl = importedNode.getAttribute("data-product-url") || requestedProductUrl;
    var newDocumentTitle = importedNode.getAttribute("data-document-title");
    var newCanonicalUrl = importedNode.getAttribute("data-canonical-url");

    if (newDocumentTitle) {
      try {
        document.title = newDocumentTitle;
      } catch (err) {
        /* لا شيء يستحق المعالجة. */
      }
    }
    if (newCanonicalUrl) {
      try {
        var canonicalLink = document.querySelector('link[rel="canonical"]');
        if (canonicalLink) {
          canonicalLink.setAttribute("href", newCanonicalUrl);
        }
      } catch (err) {
        /* لا شيء يستحق المعالجة — غياب رابط canonical لا يمنع الاستبدال. */
      }
    }

    try {
      document.dispatchEvent(
        new CustomEvent("naghmah:product-changed", {
          detail: {
            oldProductId: oldProductId,
            productId: newProductId,
            sourceSectionId: sectionId,
            productUrl: newProductUrl,
            pageRoot: importedNode
          }
        })
      );
    } catch (err) {
      /* بيئة نادرة بلا CustomEvent فعّال — لا يمنع استبدال الصفحة نفسه من العمل. */
    }

    initSection(importedNode);

    try {
      if (focusOptionValueId) {
        var refocusTarget = refocusSelect
          ? importedNode.querySelector('select[data-option-position="' + focusOptionPosition + '"]')
          : importedNode.querySelector('input[data-option-value-id="' + escapeAttrValue(focusOptionValueId) + '"]');
        if (refocusTarget) refocusTarget.focus({ preventScroll: true });
      }
    } catch (err) {
      /* محدِّد غير صالح في حالة نادرة — لا يكسر الاستبدال، فقط لا تُعاد بؤرة التركيز تحديدًا. */
    }

    var idField = importedNode.querySelector("[data-buy-buttons-variant-id]");
    var matchedVariantId = idField && idField.value ? idField.value : null;

    return { applied: true, matchedVariantId: matchedVariantId, newPageRoot: importedNode, newProductUrl: newProductUrl };
  }

  function showVariantErrorMessage(pageRoot, message) {
    showBuyMessage(pageRoot, message, "error");
  }

  /**
   * تصحيح Product V5 (بند 1/2)، مُحدَّث في Product V6 (بند 3/5): تُستدعى
   * الآن دومًا بصرف النظر عن نتيجة مطابقة محلية للـVariant — لا تحقّق محليًا
   * مسبق، لا توقّف قبل الطلب. تبني رابط Section Rendering عبر
   * buildSectionRenderingUrl (بند 5: يحافظ على selling_plan وبقية معاملات
   * الرابط الحالي، لا يُبنى بدمج نصي يحذفها). أي استجابة HTTP ناجحة (200) —
   * سواء طابقت Variant حقيقية أم أظهرت "تركيبة غير متاحة" — تُطبَّق فعليًا؛
   * Rollback يُستدعى حصرًا حين يفشل الطلب نفسه (استجابة غير ناجحة، خطأ
   * شبكة، أو HTML غير قابل للتحليل) — لا عند نجاحه بمحتوى "غير متاحة".
   *
   * `productChanged` (بند 3): صحيح حين تنتمي القيمة المُختارة لمنتج شقيق
   * مختلف ضمن Combined Listing (productUrl الفعّال يختلف عن data-product-url
   * الحالي على pageRoot). في هذه الحالة يُستبدَل [data-product-page] بالكامل
   * عبر applyProductSwap (لا #ProductInfo وحده)، لأن المنتج الجديد يحتاج
   * معرضًا/Breadcrumb/شريطًا ثابتًا/نموذج شراء مختلفين بالكامل — لا يكفي
   * تحديث جزئي.
   */
  function fetchVariantUpdate(pageRoot, sectionId, productUrl, optionValueIds, focusOptionPosition, focusOptionValueId, refocusSelect, productChanged) {
    var state = getPageState(pageRoot);
    var infoWrap = document.getElementById("ProductInfo-" + sectionId);

    if (state.variantController) {
      state.variantController.abort();
    }
    state.variantSeq += 1;
    var requestId = state.variantSeq;
    var controller = typeof AbortController === "function" ? new AbortController() : null;
    state.variantController = controller;
    var signal = controller ? controller.signal : undefined;

    if (!state.variantBusy) {
      state.variantBusy = true;
      if (infoWrap) infoWrap.setAttribute("aria-busy", "true");
      setBuyFormBusy(pageRoot, true);
      if (infoWrap) setDynamicCheckoutDisabled(infoWrap, true);
      var idField = infoWrap ? infoWrap.querySelector("[data-buy-buttons-variant-id]") : null;
      if (idField) idField.disabled = true;
    }

    var url = buildSectionRenderingUrl(productUrl, sectionId, optionValueIds);

    fetch(url, { headers: { Accept: "text/html" }, signal: signal })
      .then(function (res) {
        return res.ok ? res.text() : null;
      })
      .then(function (html) {
        if (requestId !== state.variantSeq) return; // طلب أحدث تكفَّل بحالة busy الخاصة به

        if (!html) {
          // فشل الطلب نفسه (استجابة غير ناجحة) — الحالة الوحيدة التي تستحق Rollback.
          // الجذر القديم لم يُمَس بعد في كلا الحالتين (productChanged أم لا)، فالاستعادة تصح دومًا هنا.
          rollbackVariant(pageRoot, sectionId, state);
          return;
        }

        if (productChanged) {
          var swapResult = applyProductSwap(pageRoot, sectionId, html, productUrl, focusOptionPosition, focusOptionValueId, refocusSelect);

          if (!swapResult.applied) {
            rollbackVariant(pageRoot, sectionId, state);
            return;
          }

          // الجذر تبدَّل بالكامل بعقدة DOM جديدة؛ initSection (المُستدعاة
          // داخل applyProductSwap) هي من تضبط الحالة (lastGoodInfoHTML/
          // busy/Sticky Observer/ربط الحقول) للجذر الجديد من الصفر. لا حاجة
          // لأي من ذلك على pageRoot القديم (لم يعد في DOM).
          updateUrlForSelection(swapResult.newProductUrl, swapResult.matchedVariantId, optionValueIds);
          reinitShopifyPaymentButton();
          return;
        }

        var result = applyVariantUpdate(pageRoot, sectionId, html, focusOptionPosition, focusOptionValueId, refocusSelect);

        if (!result.applied) {
          rollbackVariant(pageRoot, sectionId, state);
          return;
        }

        var freshInfo = document.getElementById("ProductInfo-" + sectionId);
        if (freshInfo) state.lastGoodInfoHTML = freshInfo.innerHTML;

        updateUrlForSelection(productUrl, result.matchedVariantId, optionValueIds);
        pageRoot.setAttribute("data-product-url", productUrl);

        reinitShopifyPaymentButton();
        bindFormAssociatedFields(pageRoot);
        finishVariantBusy(pageRoot, sectionId, state);
      })
      .catch(function (err) {
        if (err && err.name === "AbortError") return; // طلب أُلغي عمدًا لصالح طلب Variant أحدث — الأحدث يدير busy بنفسه
        if (requestId !== state.variantSeq) return;
        rollbackVariant(pageRoot, sectionId, state);
      });
  }

  function finishVariantBusy(pageRoot, sectionId, state) {
    state.variantBusy = false;
    var infoWrap = document.getElementById("ProductInfo-" + sectionId);
    var idField = infoWrap ? infoWrap.querySelector("[data-buy-buttons-variant-id]") : null;
    if (idField) idField.disabled = false;
    setBuyFormBusy(pageRoot, false);
    // تصحيح Product V4 (بند 4): إعادة ربط IntersectionObserver بعنصر أزرار
    // الشراء الجديد (بعد نجاح التحديث أو الاستعادة إلى آخر حالة ناجحة) —
    // finishVariantBusy تُستدعى من كلا المسارين (النجاح مباشرة، والفشل عبر
    // rollbackVariant)، فتغطي هذه الاستدعاءة الحالتين معًا.
    attachStickyObserver(pageRoot, sectionId);
    syncStickyBarFromInfo(pageRoot, sectionId);
    if (infoWrap) infoWrap.removeAttribute("aria-busy");
  }

  /**
   * تصحيح Product V5 (بند 2): تُستدعى حصرًا عند فشل طلب Section Rendering
   * نفسه (استجابة غير ناجحة/خطأ شبكة/HTML غير قابل للتحليل) — لا عند نجاحه
   * بمحتوى "تركيبة غير متاحة" (ذلك تطبيق ناجح عادي، يمر عبر applyVariantUpdate
   * مباشرة بلا Rollback). تستعيد آخر #ProductInfo ناجح فعليًا (سواء كان
   * Variant متاحة أو حتى "غير متاحة" ناتجة عن طلب سابق نجح فعليًا) — لا
   * تفترض دومًا أنه Variant متاحة.
   */
  function rollbackVariant(pageRoot, sectionId, state) {
    var infoWrap = document.getElementById("ProductInfo-" + sectionId);
    if (infoWrap && state.lastGoodInfoHTML != null) {
      infoWrap.innerHTML = state.lastGoodInfoHTML;
      reinitShopifyPaymentButton();
      bindFormAssociatedFields(pageRoot);
    }
    finishVariantBusy(pageRoot, sectionId, state);
    showVariantErrorMessage(
      pageRoot,
      (window.Naghmah && Naghmah.strings && Naghmah.strings.variantUpdateError) ||
        "تعذّر تحديث بيانات المنتج، أُعيدت آخر تركيبة ناجحة"
    );
  }

  /**
   * تصحيح Product V5 (بند 1/6)، مُحدَّث في Product V6 (بند 3): إعادة بناء
   * كاملة. تُجمَع معرّفات القيم المختارة لكل الخيارات (لا معرّف Variant
   * واحد). productUrl الفعّال يُقرأ مباشرة من data-product-url على القيمة
   * المُغيَّرة تحديدًا (Combined Listing) أو، إن لم تحمل رابطًا، من
   * data-product-url الحالي على pageRoot نفسه — لا حاجة لحفظه في State (كان
   * ذلك في V5)، لأن pageRoot نفسه هو مصدر الحقيقة الوحيد الآن (ويُستبدَل
   * بالكامل أصلاً عند تغيّر المنتج، فحفظ رابط في حالة مرتبطة بجذر قد يُستبدَل
   * كان بلا فائدة فعلية). productChanged تُحسَب صراحة بمقارنة الرابطين —
   * تُمرَّر لـfetchVariantUpdate لتقرر بين تحديث #ProductInfo وحده أو
   * استبدال [data-product-page] بالكامل. لا يوجد أي توقّف محلي لغياب
   * data-variant-id — الطلب يُرسَل دومًا. إن كان طلب Add جاريًا فعليًا لنفس
   * الصفحة، لا يبدأ أي طلب تبديل Variant جديد (حارس احتياطي؛ العناصر
   * معطَّلة أصلاً حينها عبر setProductInteractionBusy).
   */
  function handleVariantOptionChange(control) {
    var picker = control.closest("[data-variant-picker]");
    if (!picker) return;

    var pageRoot = getPageRoot(picker);
    if (!pageRoot) return;
    var state = getPageState(pageRoot);

    if (state.addInFlight) return;

    var sectionId = pageRoot.getAttribute("data-section-id");

    var optionValueIds = collectSelectedOptionValueIds(picker);
    if (!optionValueIds.length) return; // لا خيارات فعلية للقراءة (حالة غير متوقَّعة) — لا شيء لإرساله

    var isSelect = control.tagName === "SELECT";
    var selectedOption = isSelect ? control.options[control.selectedIndex] : null;

    var triggerProductUrl = isSelect
      ? (selectedOption ? selectedOption.getAttribute("data-product-url") : "")
      : control.getAttribute("data-product-url");

    var currentProductUrl = pageRoot.getAttribute("data-product-url");
    var targetProductUrl = triggerProductUrl || currentProductUrl;
    var productChanged = Boolean(triggerProductUrl) && triggerProductUrl !== currentProductUrl;

    var optionWrap = control.closest("[data-option-position]");
    var focusOptionPosition = optionWrap ? optionWrap.getAttribute("data-option-position") : null;
    var focusOptionValueId = isSelect
      ? (selectedOption ? selectedOption.getAttribute("data-option-value-id") : null)
      : control.getAttribute("data-option-value-id");

    fetchVariantUpdate(pageRoot, sectionId, targetProductUrl, optionValueIds, focusOptionPosition, focusOptionValueId, isSelect, productChanged);
  }

  /* ================= حقل الكمية ================= */

  function clampQuantity(wrapper, field) {
    var min = parseInt(wrapper.getAttribute("data-min"), 10);
    var max = wrapper.hasAttribute("data-max") ? parseInt(wrapper.getAttribute("data-max"), 10) : null;
    var step = parseInt(wrapper.getAttribute("data-step"), 10) || 1;
    if (isNaN(min) || min < 1) min = 1;

    var value = parseInt(field.value, 10);
    if (isNaN(value)) value = min;

    if (value < min) value = min;
    if (max != null && !isNaN(max) && value > max) value = max;

    var stepsFromMin = Math.round((value - min) / step);
    value = min + stepsFromMin * step;
    if (value < min) value = min;
    if (max != null && !isNaN(max) && value > max) value = max;

    field.value = value;
    return value;
  }

  function adjustQuantity(button, direction) {
    var wrapper = button.closest("[data-quantity-input]");
    if (!wrapper) return;
    var field = wrapper.querySelector("[data-quantity-field]");
    if (!field) return;

    var step = parseInt(wrapper.getAttribute("data-step"), 10) || 1;
    var current = parseInt(field.value, 10);
    if (isNaN(current)) current = parseInt(wrapper.getAttribute("data-min"), 10) || 1;

    field.value = current + direction * step;
    clampQuantity(wrapper, field);
  }

  /* ================= إضافة إلى السلة (Ajax) ================= */

  /**
   * تصحيح Product V4 (بند 1): كانت busy=false لا تعيد شيئًا إطلاقًا — إن لم
   * يُستبدَل الزر بمحتوى جديد من الخادم (حالة Ajax Add العادية، الزر نفسه
   * يبقى في DOM)، يبقى معطَّلاً للأبد بعد أول إضافة ناجحة. الحل: عند
   * busy=true تُحفَظ الحالة الأصلية (قبل تعطيلها قسرًا) في
   * data-busy-was-disabled — مرة واحدة فقط لكل دورة busy (لا تُكتَب فوق
   * قيمة محفوظة من استدعاء سابق لم يُنهَ بعد). عند busy=false: إن وُجدت
   * علامة محفوظة على هذا الزر تحديدًا، تُستعاد حالته الأصلية منها وتُحذَف
   * العلامة. إن لم تُوجَد علامة (حالة الزر المُستبدَل بالكامل من الخادم بعد
   * Section Rendering — عنصر DOM جديد كليًا لا يحمل أي علامة قديمة)، لا
   * يُلمَس شيء إطلاقًا: حالة `disabled` القادمة من HTML الخادم تبقى كما هي
   * (الحقيقة الفعلية لتوفر الـVariant الجديدة)، ولا تُستبدَل بعلم قديم يخص
   * Variant سابقة.
   */
  function setBuyFormBusy(pageRoot, busy) {
    var submitters = pageRoot.querySelectorAll('[data-add-to-cart-button], [data-sticky-bar-add]');
    submitters.forEach(function (btn) {
      if (busy) {
        if (!btn.hasAttribute("data-busy-was-disabled")) {
          btn.setAttribute("data-busy-was-disabled", btn.disabled ? "true" : "false");
        }
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");
      } else if (btn.hasAttribute("data-busy-was-disabled")) {
        var wasDisabled = btn.getAttribute("data-busy-was-disabled") === "true";
        btn.removeAttribute("data-busy-was-disabled");
        btn.disabled = wasDisabled;
        btn.setAttribute("aria-disabled", wasDisabled ? "true" : "false");
      }
      // لا علامة محفوظة على هذا الزر: عنصر جديد جاء من الخادم بعد Section
      // Rendering — يُترَك بلا تغيير، حالته الحالية هي الحقيقة الفعلية.
    });
  }

  /**
   * تصحيح Product V5 (بند 6): توسيع نفس نمط setBuyFormBusy (حفظ/استعادة
   * الحالة الأصلية عبر علامة data-add-busy-was-disabled) ليشمل أيضًا عناصر
   * منتقي الخيارات وحقل/أزرار الكمية — أثناء طلب Add الجاري فعليًا، يجب ألا
   * يستطيع الزائر تغيير Variant أو الكمية (سيغيّر ذلك #ProductInfo بالكامل
   * بما فيه <form> بينما FormData للطلب الجاري مأخوذة أصلاً من النسخة
   * القديمة — لا خطأ في البيانات المُرسَلة فعليًا، لكن تجربة مربكة يجب
   * منعها). بعد انتهاء busy، تُستعاد حالة كل عنصر الأصلية (عمليًا لا شيء من
   * هذه العناصر يُعطَّل خادميًا في هذا الثيم، فستكون wasDisabled=false
   * دومًا؛ العلامة تبقى موجودة للاتساق مع بقية أنماط busy في هذا الملف).
   */
  function setProductInteractionBusy(pageRoot, busy) {
    setBuyFormBusy(pageRoot, busy);

    var otherControls = pageRoot.querySelectorAll(
      '[data-variant-picker] input[data-option-value-id], ' +
        '[data-variant-picker] select[data-option-position], ' +
        '[data-quantity-field], [data-quantity-decrease], [data-quantity-increase]'
    );
    otherControls.forEach(function (el) {
      if (busy) {
        if (!el.hasAttribute("data-add-busy-was-disabled")) {
          el.setAttribute("data-add-busy-was-disabled", el.disabled ? "true" : "false");
        }
        el.disabled = true;
      } else if (el.hasAttribute("data-add-busy-was-disabled")) {
        var wasDisabled = el.getAttribute("data-add-busy-was-disabled") === "true";
        el.removeAttribute("data-add-busy-was-disabled");
        el.disabled = wasDisabled;
      }
    });

    var infoWrap = document.getElementById("ProductInfo-" + pageRoot.getAttribute("data-section-id"));
    if (busy && infoWrap) {
      setDynamicCheckoutDisabled(infoWrap, true);
    }
    // إعادة تفعيل الدفع السريع (busy=false) تُترَك لـsyncStickyBarFromInfo
    // التي تُستدعى مباشرة بعد هذه الدالة في كل من مساري نجاح/فشل Add —
    // فتُعيد الحالة الحقيقية وفق توفر الـVariant الحالية، لا تفعيلًا أعمى.
  }

  function showBuyMessage(pageRoot, text, state) {
    var messageEl = pageRoot.querySelector("[data-buy-buttons-message]");
    if (!messageEl) return;
    messageEl.textContent = text;
    messageEl.setAttribute("data-state", state);
  }

  /**
   * تصحيح Product V3 (بند 1): كان الحقل يُبحَث عنه عبر
   * form.querySelector("[data-quantity-field]") — يقتصر على أحفاد <form>
   * المباشرين فقط في DOM، بينما حقل الكمية يعيش فعليًا خارج <form> (في
   * كتلة "quantity" داخل sections/main-product.liquid، مربوطًا بالنموذج
   * حصرًا عبر form="{{ product_form_id }}") — فكان دومًا null، وتُستخدم
   * الكمية الافتراضية 1 بصرف النظر عمّا اختاره الزائر فعليًا.
   * الحل: form.elements.namedItem("quantity") يجد كل عناصر النموذج
   * الحقيقية (بما فيها المرتبطة عبر form="..." من خارج DOM الشجري
   * للنموذج) — وهذا هو السلوك الرسمي لواجهة HTMLFormElement.elements.
   * احتياط صريح إن أعادت namedItem قيمة RadioNodeList (أكثر من عنصر بنفس
   * الاسم، حالة غير متوقَّعة هنا لكن مذكورة صراحة) أو لم تجد شيئًا: البحث
   * المباشر بمحدِّد form="<id>" مطابق تمامًا لمعرّف النموذج (عبر
   * CSS.escape لسلامة القيمة داخل المحدِّد).
   */
  function resolveQuantityField(form, pageRoot) {
    var field = form.elements.namedItem("quantity");
    if (!field || (typeof RadioNodeList === "function" && field instanceof RadioNodeList)) {
      field = pageRoot.querySelector('[data-quantity-field][form="' + cssEscape(form.id) + '"]');
    }
    return field || null;
  }

  /**
   * تصحيح Product V5 (بند 6/7): state.addInFlight يمنع بدء طلب Add ثانٍ
   * لنفس الصفحة (بغضّ النظر عن وجود <form> جديد بعد استبدال Variant)؛
   * setProductInteractionBusy تعطّل منتقي الخيارات والكمية أيضًا أثناء
   * الطلب (لا فقط أزرار الإضافة كما في V4)؛ AbortController مخصَّص لطلب
   * Add (state.addController) يُتيح إلغاء الاستماع لرده عند إزالة القسم
   * (shopify:section:unload)؛ كل معالجات النجاح/الفشل تتحقق أولاً من
   * document.body.contains(pageRoot) قبل لمس أي عنصر DOM — القسم قد يكون
   * أُزيل فعليًا قبل وصول الرد، فلا داعٍ (ولا معنى) لتطبيق أي تحديث مرئي
   * عليه، رغم أن نتيجة الإضافة نفسها في سلة Shopify الحقيقية لا علاقة لها
   * بهذا التحقق (السلة تُحدَّث خادميًا بصرف النظر عمّا يحدث في واجهة صفحة
   * منتج أُزيلت). درج السلة يبقى محدَّثًا بالحالة الحقيقية النهائية بفضل
   * Naghmah.cartSync.refreshDrawerAndOpen (تسلسل طلب عام مستقل خاص بها،
   * يضمن ألا يطبِّق أي رد قديم محتوى فوق رد أحدث).
   */
  function handleBuyFormSubmit(evt, form) {
    evt.preventDefault();

    var pageRoot = getPageRoot(form);
    if (!pageRoot) return;
    var state = getPageState(pageRoot);

    if (state.addInFlight) return; // طلب Add جارٍ بالفعل لنفس صفحة المنتج

    var idInput = form.querySelector('input[name="id"]');
    var quantityField = resolveQuantityField(form, pageRoot);
    var quantityWrapper = quantityField ? quantityField.closest("[data-quantity-input]") : null;

    var variantId = idInput ? idInput.value : null;
    if (!variantId) return;

    var quantity = 1;
    if (quantityField && quantityWrapper) {
      quantity = clampQuantity(quantityWrapper, quantityField);
    }

    /* تصحيح Product V4 (بند 6): novalidate أُزيلت من {% form 'product' %}
       (product-buy-buttons.liquid) لتعمل قيود min/max/step الأصلية على
       حقل الكمية عبر التحقق الأصلي للمتصفح — لكن preventDefault أعلاه
       يمنع المتصفح من تشغيل هذا التحقق تلقائيًا لمسار Ajax هنا تحديدًا،
       فيجب استدعاؤه يدويًا: checkValidity()/reportValidity() قبل أي طلب.
       مسار الدفع السريع (submitter غير name="add") لا يُعترَض إطلاقًا في
       مستمع submit أدناه، فيبقى خاضعًا للتحقق الأصلي للمتصفح تلقائيًا (لا
       novalidate بعد الآن) دون أي كود إضافي هنا. */
    if (typeof form.checkValidity === "function" && !form.checkValidity()) {
      if (typeof form.reportValidity === "function") form.reportValidity();
      return;
    }

    var addButton = form.querySelector("[data-add-to-cart-button]");
    var submitter = evt.submitter || addButton;
    // ملاحظة: تسميات الحالة (data-add-label وما شابه) موجودة فقط على زر
    // أزرار الشراء الرئيسي (data-add-to-cart-button)، وليس على زر الشريط
    // الثابت (الذي يستخدم form="..." للإرسال عن بُعد بلا تكرار هذه
    // البيانات) — لذلك تُقرأ دومًا من addButton نفسه بصرف النظر عن الزر
    // الذي أطلق الإرسال فعليًا (submitter يبقى مستخدَمًا فقط لاحقًا كوجهة
    // إعادة التركيز الصحيحة بعد إغلاق الدرج).
    var addLabel = addButton ? addButton.getAttribute("data-add-label") : null;
    var addingLabel = addButton ? addButton.getAttribute("data-adding-label") : null;
    var addedLabel = addButton ? addButton.getAttribute("data-added-label") : null;
    var errorLabel = addButton ? addButton.getAttribute("data-error-label") : null;
    var genericErrorLabel = form.querySelector("[data-buy-buttons-message]");
    genericErrorLabel = genericErrorLabel ? genericErrorLabel.getAttribute("data-generic-error-label") : null;

    state.addInFlight = true;
    form.setAttribute("data-buy-form-busy", "true");
    setProductInteractionBusy(pageRoot, true);

    if (state.addMessageTimeout) {
      window.clearTimeout(state.addMessageTimeout);
      state.addMessageTimeout = null;
    }

    var addTextEl = addButton ? addButton.querySelector("[data-add-to-cart-text]") : null;
    if (addTextEl && addingLabel) addTextEl.textContent = addingLabel;

    var root = Naghmah.cartSync.getRoutesRoot();

    /* تصحيح Product V3 (بند 7، الجزء الثاني): تسلسل مستقل لكل طلب إضافة
       (state.addSeq) — إن أُرسل طلب إضافة جديد قبل انتهاء المؤقت
       (setTimeout) الخاص بطلب سابق ناجح، يتحقق المؤقت القديم من رقم
       تسلسله المحفوظ مقابل الأحدث ويتوقف عن تطبيق أي تغيير إن لم يعد هو
       الأحدث — بدل الكتابة فوق نص/رسالة الطلب الأحدث بعد انتهاء مدته. */
    state.addSeq += 1;
    var addRequestId = state.addSeq;

    if (state.addController) {
      try {
        state.addController.abort();
      } catch (err) {
        /* لا شيء يستحق المعالجة. */
      }
    }
    var addController = typeof AbortController === "function" ? new AbortController() : null;
    state.addController = addController;
    var addSignal = addController ? addController.signal : undefined;

    /**
     * تصحيح Product V4 (بند 9)، مؤكَّد فعليًا في Product V5 (بند 5): FormData
     * حقيقية مبنية من النموذج نفسه (form.elements، يشمل حقل الكمية المرتبط
     * عبر form="..." من خارج <form> والقيمة المُصحَّحة أعلاه عبر
     * clampQuantity، ويشمل أيضًا selling_plan/properties[...] بعد ربطها
     * برمجيًا عبر bindFormAssociatedFields عند التهيئة وبعد كل Section
     * Rendering) — تلتقط كل حقل حقيقي حاليًا في النموذج تلقائيًا، وتستبعد
     * العناصر المعطَّلة تلقائيًا (سلوك FormData/إرسال النماذج القياسي). لا
     * Content-Type يُضبَط يدويًا — المتصفح يضبط multipart/form-data مع
     * الحد الفاصل الصحيح تلقائيًا عند تمرير FormData كجسم الطلب مباشرة.
     */
    var formData = new FormData(form);

    fetch(root + "cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json"
      },
      body: formData,
      signal: addSignal
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (result) {
        state.addInFlight = false;
        if (document.body.contains(pageRoot)) {
          form.removeAttribute("data-buy-form-busy");
          setProductInteractionBusy(pageRoot, false);
          syncStickyBarFromInfo(pageRoot, pageRoot.getAttribute("data-section-id"));
        }

        if (!result.ok) {
          var apiError = new Error("add_to_cart_failed");
          apiError.apiResult = result;
          throw apiError;
        }

        if (addRequestId !== state.addSeq) return; // طلب أحدث تولّى عرض حالته الخاصة
        if (!document.body.contains(pageRoot)) return; // القسم أُزيل — السلة الحقيقية تحدَّثت خادميًا بصرف النظر، لا داعٍ لتحديث واجهة غير موجودة

        if (addTextEl && addedLabel) addTextEl.textContent = addedLabel;
        else if (addTextEl && addLabel) addTextEl.textContent = addLabel;

        showBuyMessage(pageRoot, addedLabel || "", "success");
        Naghmah.cartSync.refreshDrawerAndOpen(root, submitter || addButton);

        state.addMessageTimeout = window.setTimeout(function () {
          if (addRequestId !== state.addSeq) return; // طلب أحدث غيَّر الحالة بالفعل — لا تُعِد تعيينها فوقه
          if (!document.body.contains(pageRoot)) return;
          if (addTextEl && addLabel) addTextEl.textContent = addLabel;
          showBuyMessage(pageRoot, "", "");
        }, 2200);
      })
      .catch(function (err) {
        state.addInFlight = false;
        if (err && err.name === "AbortError") return; // أُلغي بسبب إزالة القسم — لا تطبيق لأي حالة مرئية بعد الآن

        if (document.body.contains(pageRoot)) {
          form.removeAttribute("data-buy-form-busy");
          setProductInteractionBusy(pageRoot, false);
          syncStickyBarFromInfo(pageRoot, pageRoot.getAttribute("data-section-id"));
        }

        if (addRequestId !== state.addSeq) return;
        if (!document.body.contains(pageRoot)) return;

        if (addTextEl && addLabel) addTextEl.textContent = addLabel;

        /* تصحيح Product V3 (بند 7، الجزء الأول): بدل استبدال رسالة الخادم
           الحقيقية دائمًا برسالة عامة ثابتة، تُقرأ description أو message
           الفعليتان من استجابة cart/add.js (هذا هو شكل خطأ Shopify الرسمي
           عند 422 Unprocessable Entity — كمية تتجاوز المتاح، Variant غير
           متاحة، إلخ) وتُعرَضان عبر textContent (لا innerHTML) حرفيًا؛
           الرسالة العامة تبقى فقط احتياطًا نادرًا لفشل شبكة/خادم بلا جسم
           JSON فعلي (مثال: انقطاع اتصال قبل وصول أي رد). */
        var apiData = err && err.apiResult && err.apiResult.data;
        var realMessage = apiData && (apiData.description || apiData.message);
        showBuyMessage(pageRoot, realMessage || errorLabel || genericErrorLabel || "", "error");
      });
  }

  /* ================= مشاركة المنتج ================= */

  function handleShareClick(button) {
    var url = button.getAttribute("data-share-url");
    var title = button.getAttribute("data-share-title");
    var copiedLabel = button.getAttribute("data-share-copied-label");

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {
        /* المستخدم ألغى المشاركة أو رفضتها المنصة — لا خطأ يستحق الإزعاج. */
      });
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        if (copiedLabel) {
          var original = button.getAttribute("data-original-label");
          if (!original) {
            original = button.textContent;
            button.setAttribute("data-original-label", original);
          }
          var span = button.querySelector("span");
          if (span) span.textContent = copiedLabel;
          window.setTimeout(function () {
            if (span) span.textContent = original.replace(/^\s+|\s+$/g, "");
          }, 1800);
        }
      });
    }
  }

  /* ================= الربط المفوَّض (مرة واحدة فقط) ================= */

  function bindDelegatedOnce() {
    if (delegatedBound) return;
    delegatedBound = true;

    document.addEventListener("change", function (evt) {
      /* تصحيح Product V5 (بند 1): المحدِّد يعتمد الآن على data-option-value-id
         (فريد لكل قيمة، لا اسم القيمة وحده) لعناصر الأزرار، مع الإبقاء على
         select[data-option-position] لنمط القائمة المنسدلة كما في V4. */
      var variantControl = evt.target.closest(
        "[data-variant-picker] input[data-option-value-id], " +
          "[data-variant-picker] select[data-option-position]"
      );
      if (variantControl) {
        handleVariantOptionChange(variantControl);
        return;
      }
      if (evt.target.matches("[data-quantity-field]")) {
        var wrapper = evt.target.closest("[data-quantity-input]");
        if (wrapper) clampQuantity(wrapper, evt.target);
      }
    });

    document.addEventListener("click", function (evt) {
      var decreaseBtn = evt.target.closest("[data-quantity-decrease]");
      if (decreaseBtn) {
        adjustQuantity(decreaseBtn, -1);
        return;
      }
      var increaseBtn = evt.target.closest("[data-quantity-increase]");
      if (increaseBtn) {
        adjustQuantity(increaseBtn, 1);
        return;
      }
      var shareBtn = evt.target.closest("[data-share-button]");
      if (shareBtn) {
        handleShareClick(shareBtn);
        return;
      }
    });

    document.addEventListener("submit", function (evt) {
      if (!evt.target.matches(".product-form")) return;

      // تصحيح Dynamic Checkout (Product V2): كان يُعترَض كل submit على هذا
      // النموذج بلا شرط، بما فيه إرسال زر الشراء المباشر (Apple Pay/Shop
      // Pay وغيرها الناتجة عن {{ form | payment_button }}) — فيُحوَّل خطأً
      // إلى طلب Ajax على cart/add.js بدل بدء تدفق الدفع المباشر الحقيقي.
      // الآن يُعترَض فقط حين يكون submitter هو زر الإضافة الحقيقي
      // (name="add") تحديدًا؛ أي submitter آخر (بما فيه أزرار الدفع
      // المباشر، أو حتى submit بلا submitter معروف) يُترَك للمتصفح ليُكمل
      // تدفقه الأصلي دون preventDefault إطلاقًا.
      if (!evt.submitter || evt.submitter.name !== "add") return;

      handleBuyFormSubmit(evt, evt.target);
    });
  }

  function initSection(sectionEl) {
    var pageRoot = sectionEl && sectionEl.matches && sectionEl.matches("[data-product-page]")
      ? sectionEl
      : (sectionEl ? sectionEl.querySelector("[data-product-page]") : document.querySelector("[data-product-page]"));
    if (!pageRoot) return;

    initGallery(pageRoot);

    var sectionId = pageRoot.getAttribute("data-section-id");
    if (sectionId) {
      var state = getPageState(pageRoot);
      // لقطة الحالة الابتدائية الناجحة (لحظة التحميل من الخادم) — تتيح
      // الاستعادة الفورية لو فشل أول طلب تبديل Variant فعليًا يحاوله الزائر.
      if (state.lastGoodInfoHTML == null) {
        var infoWrap = document.getElementById("ProductInfo-" + sectionId);
        if (infoWrap) state.lastGoodInfoHTML = infoWrap.innerHTML;
      }
      attachStickyObserver(pageRoot, sectionId);
      bindFormAssociatedFields(pageRoot);
    }
  }

  if (Naghmah.registerSection) {
    Naghmah.registerSection("main-product", initSection);
  }

  Naghmah.onReady(function () {
    bindDelegatedOnce();
    /* تصحيح Product V4 (بند 8): querySelector يجد أول [data-product-page]
       فقط — لو وُجد أكثر من قسم main-product واحد عند التحميل الأول
       (مثال: محرر الثيم، أو صفحة مخصَّصة تُكرِّر القسم عمدًا)، تبقى الأقسام
       الأخرى بلا تهيئة إطلاقًا (لا معرض يعمل، لا منتقي، لا حالة WeakMap).
       querySelectorAll + forEach تُهيّئ كل قسم موجود فعليًا عند التحميل. */
    document.querySelectorAll("[data-product-page]").forEach(function (pageRoot) {
      initSection(pageRoot);
    });
  });
})();
